import { JsonUtils } from '../../utils/json.util'

export class Exams {
    // Exam

    private _exams: string[] | undefined
    private _suspect: string | undefined
    private _birads_usg_mammary: string | undefined | null
    private _birads_mammography: string | undefined | null
    private _start_date_anatomopatologic: string | undefined | null
    private _end_date_anatomopatologic: string | undefined | null
    private _start_date_immunohistochemistry: string | undefined | null
    private _end_date_immunohistochemistry: string | undefined | null
    private _start_date_cytopathological: string | undefined | null
    private _end_date_cytopathological: string | undefined | null
    private _date_mammography: string | undefined | null
    private _date_mammotome: string | undefined | null
    private _date_usg_mammary: string | undefined | null
    private _date_needling: string | undefined | null
    private _date_puncture: string | undefined | null
    private _date_core_biopsy: string | undefined | null
    private _date_genetic_test: string | undefined | null
    private _date_appointment: string | undefined | null
    private _date_surgery: string | undefined | null
    private _doctor_mammography: string | undefined
    private _service_mammography: string | undefined
    private _doctor_usg_mammary: string | undefined
    private _service_usg_mammary: string | undefined

    constructor() {
        this._exams = []
    }

    // exams
    get exams(): string[] | undefined {
        return this._exams
    }

    set exams(value: string[] | undefined) {
        this._exams = value
    }

    get birads_mammography():string | undefined | null {
        return this._birads_mammography
    }

    set birads_mammography(value: string | undefined | null) {
        this._birads_mammography = value
    }
    get birads_usg_mammary(): string | undefined | null {
        return this._birads_usg_mammary
    }

    set birads_usg_mammary(value: string | undefined | null) {
        this._birads_usg_mammary = value
    }
    get suspect(): string | undefined {
        return this._suspect
    }

    set suspect(value: string | undefined) {
        this._suspect = value
    }

    get start_date_anatomopatologic(): string | undefined | null {
        return this._start_date_anatomopatologic
    }

    set start_date_anatomopatologic(value: string | undefined | null) {
        this._start_date_anatomopatologic = value
    }
    get end_date_anatomopatologic(): string | undefined | null {
        return this._end_date_anatomopatologic
    }

    set end_date_anatomopatologic(value: string | undefined | null) {
        this._end_date_anatomopatologic = value
    }
    get start_date_immunohistochemistry(): string | undefined | null {
        return this._start_date_immunohistochemistry
    }

    set start_date_immunohistochemistry(value: string | undefined | null) {
        this._start_date_immunohistochemistry = value
    }
    get end_date_immunohistochemistry(): string | undefined | null {
        return this._end_date_immunohistochemistry
    }

    set end_date_immunohistochemistry(value: string | undefined | null) {
        this._end_date_immunohistochemistry = value
    }

    set start_date_cytopathological(value: string | undefined | null) {
        this._start_date_cytopathological = value
    }
    get start_date_cytopathological(): string | undefined | null {
        return this._start_date_cytopathological
    }

    get end_date_cytopathological(): string | undefined | null {
        return this._end_date_cytopathological
    }

    set end_date_cytopathological(value: string | undefined | null) {
        this._end_date_cytopathological = value
    }

    get date_mammography(): string | undefined | null {
        return this._date_mammography
    }

    set date_mammography(value: string | undefined | null) {
        this._date_mammography = value
    }
    get date_mammotome(): string | undefined | null {
        return this._date_mammotome
    }

    set date_mammotome(value: string | undefined | null) {
        this._date_mammotome = value
    }
    get date_usg_mammary(): string | undefined | null {
        return this._date_usg_mammary
    }

    set date_usg_mammary(value: string | undefined | null) {
        this._date_usg_mammary = value
    }
    get date_needling(): string | undefined | null {
        return this._date_needling
    }

    set date_needling(value: string | undefined | null) {
        this._date_needling = value
    }
    get date_puncture(): string | undefined | null {
        return this._date_puncture
    }
    set date_puncture(value: string | undefined | null) {
        this._date_puncture = value
    }
    set date_core_biopsy(value: string | undefined | null) {
        this._date_core_biopsy = value
    }
    get date_core_biopsy(): string | undefined | null {
        return this._date_core_biopsy
    }
    set date_genetic_test(value: string | undefined | null) {
        this._date_genetic_test = value
    }
    get date_genetic_test(): string | undefined | null {
        return this._date_genetic_test
    }
    set date_appointment(value: string | undefined | null) {
        this._date_appointment = value
    }
    get date_appointment(): string | undefined | null {
        return this._date_appointment
    }
    set date_surgery(value: string | undefined | null) {
        this._date_surgery = value
    }
    get date_surgery(): string | undefined | null {
        return this._date_surgery
    }
    set doctor_mammography(value: string | undefined) {
        this._doctor_mammography = value
    }
    get doctor_mammography(): string | undefined {
        return this._doctor_mammography
    }
    set service_mammography(value: string | undefined) {
        this._service_mammography = value
    }
    get service_mammography(): string | undefined {
        return this._service_mammography
    }
    set doctor_usg_mammary(value: string | undefined) {
        this._doctor_usg_mammary = value
    }
    get doctor_usg_mammary(): string | undefined {
        return this._doctor_usg_mammary
    }
    set service_usg_mammary(value: string | undefined) {
        this._service_usg_mammary = value
    }
    get service_usg_mammary(): string | undefined {
        return this._service_usg_mammary
    }

    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Exams {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }


        // Exams
        if (json.exams !== undefined) {
            this.exams = json.exams
        }
        if (json.birads_mammography !== undefined) {
            this.birads_mammography = json.birads_mammography
        }
        if (json.birads_usg_mammary !== undefined) {
            this.birads_usg_mammary = json.birads_usg_mammary
        }
        if (json.suspect !== undefined) {
            this.suspect = `${json.suspect}`
        }
        if (json.start_date_anatomopatologic !== undefined) {
            this.start_date_anatomopatologic = json.start_date_anatomopatologic
        }
        if (json.end_date_anatomopatologic !== undefined) {
            this.end_date_anatomopatologic = json.end_date_anatomopatologic
        }
        if (json.start_date_cytopathological !== undefined) {
            this.start_date_cytopathological = json.start_date_cytopathological
        }
        if (json.end_date_cytopathological !== undefined) {
            this.end_date_cytopathological = json.end_date_cytopathological
        }
        if (json.start_date_immunohistochemistry !== undefined) {
            this.start_date_immunohistochemistry = json.start_date_immunohistochemistry
        }
        if (json.end_date_immunohistochemistry !== undefined) {
            this.end_date_immunohistochemistry = json.end_date_immunohistochemistry
        }
        if (json.date_mammography !== undefined) {
            this.date_mammography = json.date_mammography
        }
        if (json.date_mammotome !== undefined) {
            this.date_mammotome = json.date_mammotome
        }
        if (json.date_usg_mammary !== undefined) {
            this.date_usg_mammary = json.date_usg_mammary
        }
        if (json.date_needling !== undefined) {
            this.date_needling = json.date_needling
        }
        if (json.date_puncture !== undefined) {
            this.date_puncture = json.date_puncture
        }
        if (json.date_core_biopsy !== undefined) {
            this.date_core_biopsy = json.date_core_biopsy
        }
        if (json.date_genetic_test !== undefined) {
            this.date_genetic_test = json.date_genetic_test
        }
        if (json.date_appointment !== undefined) {
            this.date_appointment = json.date_appointment
        }
        if (json.date_surgery !== undefined) {
            this.date_surgery = json.date_surgery
        }
        if (json.doctor_mammography !== undefined) {
            this.doctor_mammography = json.doctor_mammography
        }
        if (json.service_mammography !== undefined) {
            this.service_mammography = json.service_mammography
        }
        if (json.doctor_usg_mammary !== undefined) {
            this.doctor_usg_mammary = json.doctor_usg_mammary
        }
        if (json.service_usg_mammary !== undefined) {
            this.service_usg_mammary = json.service_usg_mammary
        }
        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {

        return {
            // Exams
            exams: this.exams || undefined,
            birads_mammography: (typeof this.birads_mammography === 'string' ||
                typeof this.birads_mammography === 'number') ?
                this.birads_mammography : null,
            birads_usg_mammary: (typeof this.birads_usg_mammary === 'string' ||
                typeof this.birads_usg_mammary === 'number') ?
                this.birads_usg_mammary : null,
            suspect: this.suspect ? this.suspect === "true" : undefined,
            start_date_anatomopatologic: this.start_date_anatomopatologic || undefined,
            end_date_anatomopatologic: this.end_date_anatomopatologic || undefined,
            start_date_cytopathological: this.start_date_cytopathological || undefined,
            end_date_cytopathological: this.end_date_cytopathological || undefined,
            start_date_immunohistochemistry: this.start_date_immunohistochemistry || undefined,
            end_date_immunohistochemistry: this.end_date_immunohistochemistry || undefined,
            date_mammography: this.date_mammography || undefined,
            date_mammotome: this.date_mammotome || undefined,
            date_usg_mammary: this.date_usg_mammary || undefined,
            date_needling: this.date_needling || undefined,
            date_puncture: this.date_puncture || undefined,
            date_core_biopsy: this.date_core_biopsy || undefined,
            date_genetic_test: this.date_core_biopsy || undefined,
            date_appointment: this.date_core_biopsy || undefined,
            date_surgery: this.date_surgery || undefined,
            doctor_mammography: this.doctor_mammography || undefined,
            service_mammography: this.service_mammography || undefined,
            doctor_usg_mammary: this.doctor_usg_mammary || undefined,
            service_usg_mammary: this.service_usg_mammary || undefined
        }
    }
}  